import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

// eslint-disable-next-line no-unused-vars
const URL = process.env.VUE_APP_API_URL

class FaturamentoPromedServico extends Servico {
  constructor() {
    super('faturamentoPromed')
  }

  recuperarRelatorioFaturamentoPromed(
    { params, id } = { params: null, id: '' }
  ) {
    store.setCarregando()
    return axios
      .get(`${URL}/relatorio_promed/${id}`, {
        params: { ...params, limit: 999999 },
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  enviarRelatorioFaturamentoPromed(data) {
    store.setCarregando()
    return axios
      .post(`${URL}/relatorio_promed`, data, {
        header: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  relatorioFaturamentoPromed(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/relatorioFaturamentoPromed`, {
        params: filtro,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }
}

export default FaturamentoPromedServico
